import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { IntercityLines } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/intercity-lines.interface';
import { ScheduleService } from 'src/app/modules/route-planner/services/schedule/schedule.service';

@Component({
    selector: 'app-lines-between-cities-results-list',
    templateUrl: './lines-between-cities-results-list.component.html',
    styleUrls: ['./lines-between-cities-results-list.component.scss'],
    standalone: false
})
export class LinesBetweenCitiesResultsListComponent {
  @Output() onResultClick = new EventEmitter<IntercityLines>();
  @Input() results: IntercityLines[];
}
